import breakpoints from './breakpoints';
import colors from './colors';

export default {
  breakpoints,
  colors,
};
